<template>
  <transition name="router-fade" mode="out-in">
    <div id="app">
      <!--<header-v1 img1="../../../static/img/m-youke-logo.png" v-if="$route.name == 'youke-home' || $route.name == 'youke-index'"></header-v1>-->
      <!--<header-v1 v-else></header-v1>-->
      <router-view></router-view>
    </div>
  </transition>
</template>

<script>
  import headerV1 from '@/components/common/headerV1'

  export default {
    name: 'app',
    components: {
      headerV1
    },
    watch: {
      $route(to, from) {
        ZMSDK.onEvent('进入页面', '陪练m站', {
          bu: '3'
        })
      }
    }
  }
</script>

<style lang="scss">
  @import "styles/common.scss";
/*  .router-fade-enter-active, .router-fade-leave-active {
    transition: opacity .3s;
  }
  .router-fade-enter, .router-fade-leave-active {
    opacity: 0;
  }*/
</style>
